import { signOut } from 'next-auth/react'

const appUrl = process.env.NEXT_PUBLIC_APP_URL || 'https://local.scalis.io:3000'

export const handleSignOut = async () => {
  await signOut({ redirect: false })
  window.location.href = `${process.env.NEXT_PUBLIC_COGNITO_DOMAIN}/logout?client_id=${process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID}&logout_uri=${encodeURIComponent(appUrl)}`
}
